// extracted by mini-css-extract-plugin
export default {"service":"Service_service__Xqmq7","cardImgZoom":"Service_cardImgZoom__x3-tt"};